import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
interface AiComparison {
  label: string;
  theirs: string;
  ours: string;
}
const comparisons: AiComparison[] = [{
  label: 'Zillow\u2019s AI',
  theirs: 'Listens to your connection calls. Grades your agents. Scores your team and routes leads accordingly. It works for Zillow.',
  ours: 'Ours answers those calls live, on your side of the phone, and books the appointment their AI is grading you on.'
}, {
  label: 'Your CRM\u2019s AI',
  theirs: 'Sends the first text, then hands off to nobody. No voice, no calendar, no follow-through. It works for the software vendor\u2019s renewal numbers.',
  ours: 'Ours works the lead to a booked appointment across voice and text, and writes every word back into that same CRM.'
}, {
  label: 'The portals\u2019 auto-responders',
  theirs: 'Tell the buyer someone will reach out. The buyer keeps calling agents until a human answers.',
  ours: 'Ours is the answer. Live, qualified, on the right agent\u2019s calendar before the next call gets made.'
}];
export function TheirAiOursSection() {
  return <section id="their-ai" aria-labelledby="their-ai-title" className="border-b border-white/5 bg-ink-900" data-id="element-507" data-mp="3tji1pwt7igo8">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-508" data-mp="2cxeko69vswh">
        <Reveal data-id="element-509" data-mp="q316vze0g686">
          <h2 id="their-ai-title" className="max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-510" data-mp="q3b15z638zjo">
            You already have AI everywhere. None of it works for you.
          </h2>
        </Reveal>

        <ul className="mt-10 space-y-5" data-id="element-511" data-mp="lahwtcej7t84">
          {comparisons.map((item, index) => <li key={item.label} data-id="element-512" data-mp="190c8vrr11drb" data-mpi={index}>
              <Reveal delay={0.06 * index} data-id="element-513" data-mp="18z9hlipsl9av">
                <div className="overflow-hidden rounded-2xl border border-white/10 bg-ink-800" data-id="element-514" data-mp="1drao0o0a45sz">
                  <div className="border-b border-white/10 bg-ink-700 px-6 py-3" data-id="element-515" data-mp="1nnjav7yjb1e2">
                    <p className="font-display text-sm font-semibold uppercase tracking-[0.12em] text-white/60" data-id="element-516" data-mp="1nl6u2y4iix2l">
                      {item.label}
                    </p>
                  </div>

                  <div className="grid gap-px bg-white/10 md:grid-cols-2" data-id="element-517" data-mp="1dr7tw4o01nda">
                    <div className="bg-ink-800 p-6" data-id="element-518" data-mp="19n8e5oajmskz">
                      <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-white/35" data-id="element-519" data-mp="14p6yldcbtbe9">
                        What it does
                      </p>
                      <p className="mt-3 text-sm leading-relaxed text-white/55" data-id="element-520" data-mp="zw5g6vcwutpx">
                        {item.theirs}
                      </p>
                    </div>

                    <Reveal delay={0.28} offset={12} className="bg-ink-800" data-id="element-521" data-mp="q1djruv2ecwq">
                      <div className="h-full border-l-2 border-brand bg-brand/[0.06] p-6" data-id="element-522" data-mp="lx5pli5u84r4">
                        <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.12em] text-brand" data-id="element-523" data-mp="gyuhpcz3s4bj">
                          <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-524" data-mp="2slxxmh06kkzn" />
                          What ours does
                        </p>
                        <p className="mt-3 flex items-start gap-3 text-sm leading-relaxed text-white/85" data-id="element-525" data-mp="31mmfjmsp35ht">
                          <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-526" data-mp="36mh5no4nbr1t" />
                          <span data-id="element-527" data-mp="2dx1u8x92jw5d">{item.ours}</span>
                        </p>
                      </div>
                    </Reveal>
                  </div>
                </div>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.1} className="mt-10 max-w-2xl border-l-2 border-brand pl-5" data-id="element-528" data-mp="2noxt4aizbqan">
          <p className="font-display text-lg leading-relaxed text-white/85 sm:text-xl" data-id="element-529" data-mp="1q6xnwi4hxiao">
            The AI around you was built to measure you or replace your first text. Ours was
            built to win you the lead.
          </p>
        </Reveal>
      </div>
    </section>;
}